import React from 'react'
import {
	RefundBlock,
	RefundSeparator,
	RefundSubTitle,
	RefundStoreCreditBlockShippingOptionInfo,
	RefundSeparatorWrapper,
} from './../style'
import { useDispatch } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { ButtonFull } from 'components/Form/Button'
import Instructions from 'components/InstructionList'
import RefundTotal from 'components/RefundTotal'
import PopupTitle from './PopupTitle'
import ItemPreview from 'components/ItemPreview'
import { SS } from 'utils/common'
import history from 'utils/history'
import { clearHandledItems } from 'components/Steps/thunk'
import { setRefundStateToDefault } from '../thunk'
import { Icon } from 'components/Icon'

const getReturnedPreviews = (items, defaultCurrency) => {
	let previews = []

	for (let id in items) {
		if (items.hasOwnProperty(id)) {
			previews.push(items[id])
		}
	}

	return previews.map((currentItem) => {
		return (
			<ItemPreview
				key={`final_return_${currentItem.orderItemExternalId}`}
				noIcon
				gray
				max472
				margin
				currency={currentItem.currency || defaultCurrency}
				price={currentItem.price}
				name={currentItem.name}
				color={currentItem.color}
				size={currentItem.size}
				imageUrl={currentItem.imageUrl}
			/>
		)
	})
}

/**
 * getNewExchangePreviews {Function}
 * @description - based on newExchange collection search items from selected items and pick the specific one.
 * @return {React Collection}
 * */
const getNewExchangePreviews = (
	newExchanges,
	combinedItems,
	defaultCurrency
) => {
	let newProducts = []

	for (let key in newExchanges) {
		if (newExchanges.hasOwnProperty(key)) {
			let currentExchangeItem = newExchanges[key]
			let currentItem = combinedItems[key]
			let productVariantExternalId =
				currentExchangeItem.productVariant.productVariantExternalId
			let selectedVariants = []
			if (currentItem && currentItem.variants) {
				for (let keyVariant in currentItem.variants) {
					if (currentItem.variants.hasOwnProperty(keyVariant)) {
						let currentVariant = currentItem.variants[keyVariant]
						if (
							currentVariant.productVariantExternalId ==
								productVariantExternalId ||
							currentVariant.productExternalId ==
								productVariantExternalId
						) {
							selectedVariants.push(currentVariant)
						}
					}
				}
				if (selectedVariants.length) {
					newProducts.push(selectedVariants[0])
				}
			}
		}
	}

	return newProducts.map((currentItem) => {
		return (
			<ItemPreview
				key={`final_new_${currentItem.productExternalId}`}
				noIcon
				gray
				max472
				margin
				currency={currentItem.currency || defaultCurrency}
				price={currentItem.price}
				name={currentItem.name}
				color={currentItem.color}
				size={currentItem.size}
				imageUrl={currentItem.imageUrl}
			/>
		)
	})
}

const ExchangeFinalPopup = ({
	instructions = [],
	items = [],
	totals = {},
	currency = '',
	isShippingOptionSelected = false,
	shipmentOptionInStore = {
		selected: false,
	},
}) => {
	const dispatch = useDispatch()
	let {
		refund = {},
		exchange = {},
		reclamation = {},
		newExchange = {},
	} = items

	let isRefundItems = !!(refund && Object.keys(refund).length)
	let isExchangeItems = !!(exchange && Object.keys(exchange).length)
	let isComplaintItems = !!(reclamation && Object.keys(reclamation).length)
	let isNewExchangeItems = !!(newExchange && Object.keys(newExchange).length)
	let combinedItems = {}

	if (isRefundItems) {
		combinedItems = {
			...combinedItems,
			...refund,
		}
	}
	if (isComplaintItems) {
		combinedItems = {
			...combinedItems,
			...reclamation,
		}
	}
	if (isExchangeItems) {
		combinedItems = {
			...combinedItems,
			...exchange,
		}
	}

	return (
		<RefundBlock>
			<PopupTitle green icon='checkRadial'>
				<FormattedMessage
					id='gcFinal.dialog.titleExchange'
					defaultMessage='YOUR EXCHANGE IS REGISTERED'
				/>
			</PopupTitle>

			<RefundSeparatorWrapper>
				<Icon component='RefundSeparator' />
			</RefundSeparatorWrapper>

			{!!isNewExchangeItems && (
				<>
					<RefundSubTitle>
						<FormattedMessage
							id='cart.expanded.newGoods.title'
							defaultMessage='YOUR NEW PRODUCTS'
						/>
					</RefundSubTitle>

					{getNewExchangePreviews(
						newExchange,
						combinedItems,
						currency
					)}

					<RefundSeparator />
				</>
			)}

			{isRefundItems || isExchangeItems || isComplaintItems ? (
				<RefundSubTitle>
					<FormattedMessage
						id='cart.expanded.returnedGoods.title'
						defaultMessage='YOUR RETURNS'
					/>
				</RefundSubTitle>
			) : (
				''
			)}

			{!!isRefundItems && <>{getReturnedPreviews(refund, currency)}</>}

			{!!isComplaintItems && (
				<>{getReturnedPreviews(reclamation, currency)}</>
			)}

			{!!isExchangeItems && (
				<>{getReturnedPreviews(exchange, currency)}</>
			)}

			<Instructions items={instructions} />

			{/*<RefundSeparator />*/}

			{!!isShippingOptionSelected && (
				<RefundStoreCreditBlockShippingOptionInfo>
					<FormattedMessage
						id='shippingSelector.selectedOptionTitle'
						defaultMessage='Shipping option:'
					/>{' '}
					{shipmentOptionInStore.selected ? (
						<FormattedMessage
							id={`shippingSelector.options.names.${shipmentOptionInStore.type}`}
							defaultMessage=' '
						/>
					) : (
						<FormattedMessage
							id='shippingSelector.options.names.LABEL_BY_EMAIL'
							defaultMessage=' '
						/>
					)}
				</RefundStoreCreditBlockShippingOptionInfo>
			)}

			<RefundTotal totals={totals} currency={currency} />

			<ButtonFull
				dark
				w419
				onClick={() => {
					SS.remove('steps')
					dispatch(clearHandledItems())
					dispatch(setRefundStateToDefault())
					history.push('/orders')
				}}
			>
				<FormattedMessage
					id='gcFinal.dialog.gotIt'
					defaultMessage='OK'
				/>
			</ButtonFull>
		</RefundBlock>
	)
}

export default ExchangeFinalPopup
